function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67907",
  "data-name": "Group 67907",
  transform: "translate(-945.972 -355.972)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_332",
  "data-name": "Rectangle 332",
  width: 15,
  height: 15,
  rx: 5,
  transform: "translate(947.472 357.472)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.54
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_333",
  "data-name": "Rectangle 333",
  width: 15,
  height: 15,
  rx: 5,
  transform: "translate(971.472 357.472)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.54
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_334",
  "data-name": "Rectangle 334",
  width: 15,
  height: 15,
  rx: 5,
  transform: "translate(996.472 357.472)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.54
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_335",
  "data-name": "Rectangle 335",
  width: 15,
  height: 15,
  rx: 5,
  transform: "translate(947.472 381.472)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.54
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_336",
  "data-name": "Rectangle 336",
  width: 15,
  height: 15,
  rx: 5,
  transform: "translate(971.472 381.472)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_337",
  "data-name": "Rectangle 337",
  width: 15,
  height: 15,
  rx: 5,
  transform: "translate(996.472 381.472)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.54
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_338",
  "data-name": "Rectangle 338",
  width: 15,
  height: 15,
  rx: 5,
  transform: "translate(947.472 406.472)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.54
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_339",
  "data-name": "Rectangle 339",
  width: 15,
  height: 15,
  rx: 5,
  transform: "translate(971.472 406.472)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.54
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_340",
  "data-name": "Rectangle 340",
  width: 15,
  height: 15,
  rx: 5,
  transform: "translate(996.472 406.472)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.54
}));

function SvgRoundedBoxs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedBoxs);
export default __webpack_public_path__ + "static/media/roundedBoxs.beb5dc6a.svg";
export { ForwardRef as ReactComponent };